"use client";
import policeplatform_banner from "@/assets/images/banners/policeplatform_banner.png";
import TabList from "@/components/newtabList";
import Banner from "@/components/banner";
import { useTabsActive } from "@/utils/commonHooks";
import styles from "./index.module.scss";
export default function PartyPolicePlatform({ children }) {
  const [activeIndex, changeActive]: any = useTabsActive("policeplatform");

  return (
    <div className={styles.policeBox}>
{  /*    <img
        src={policeplatform_banner.src}
        className={styles.policeplatform_banner}
        alt=""
/>*/}
      <Banner bannerId="policeplatform" />
      <div className={styles.tabBox}>
        <TabList
          tabId="policeplatform"
          changeActive={changeActive}
          activeIndex={activeIndex}
        />
        {children}
      </div>
    </div>
  );
}
